import { useState, useRef, useContext } from 'react';
import {
  Box, 
  Fab,
  Menu,
  IconButton,
  Tooltip,
  useMediaQuery
} from '@mui/material';

import { styled } from '@mui/system';

import {
  Edit as EditIcon,
  Add as AddIcon,
} from '@mui/icons-material';

import { 
  BrandModal,
  CategoryModal,
  PriceInfoModal,
  PriceModal,
  RetailPriceModal,
  MarkupModal,
  QuantityModal,
  DeliveryModal,
  CommitedModal,
  ReceivedModal,
  NoteModal,
  OrderNumberModal,
  ShopifyImportModal,
  SquareImportModal,

  CopyModal,
  DeleteModal,
  MoveModal,
  MergeModal,
  PrintModal,
} from './BulkEditModals'

import { Gallery } from 'components/Gallery'
import { Product, AuthContext } from 'components'

export const stopPropagationForTab = (event) => {
  event.stopPropagation();
};


export const FloatingActionButtons = (props) => {
  const { items, selected, isFullScreen, clearSelection, createProduct } = props // table.current.getRow(item)
  const { accountIntegrations, account } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const editButtonRef = useRef();
  const open = Boolean(anchorEl);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  const handleClick = (event) => {
    // setAnchorEl(event.target);
    setAnchorEl(editButtonRef.current);
  };

  const handleClose = () => {
    setTimeout(() => {
      setAnchorEl(null)
    }, 15);
  };

  return (
    <Box>
      <Box className="custom-fab">
        <Fab disableRipple component="div" color="secondary" aria-label="add">
          <Tooltip title="Add Product" placement='bottom' slotProps={{ popper: { modifiers: [ { name: 'offset', options: { offset: [0, 10] } } ] } }}>
            <span>
              <IconButton onClick={createProduct}>
                <AddIcon sx={{color: 'white'}} />
              </IconButton>
            </span>
          </Tooltip>
        </Fab>
        <Tooltip title="Move" placement='bottom' slotProps={{ popper: { modifiers: [ { name: 'offset', options: { offset: [0, 10] } } ] } }}>
          <span style={{ margin: 0, marginLeft: 5 }}>
            <MoveModal selected={selected} items={items} />
          </span>
        </Tooltip>
        <Tooltip title="Mark Received" placement='bottom' slotProps={{ popper: { modifiers: [ { name: 'offset', options: { offset: [0, 10] } } ] } }}>
          <span style={{ margin: 0, marginLeft: 5 }}>
            <ReceivedModal selected={selected} items={items}/>
          </span>
        </Tooltip>
        {account?.features?.shopify && Object.keys(accountIntegrations?.shopify_v2||{}).length > 0? (
          <span style={{ margin: 0, marginLeft: 5 }}>
            <ShopifyImportModal selected={selected} items={items} onClose={handleClose} />
          </span>
        ) : null}
        {accountIntegrations?.square && (
          <span style={{ margin: 0, marginLeft: 5 }}>
            <SquareImportModal selected={selected} items={items} onClose={handleClose} />
          </span>
        )}
        <Fab disableRipple component="div" disabled={!selected} color="secondary" aria-label="edit" variant="extended" onClick={handleClick}>
          <EditIcon ref={editButtonRef} />
          Bulk edit
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <BrandModal onClose={handleClose} items={items}/>
            <CategoryModal onClose={handleClose} items={items}/>
            <PriceModal onClose={handleClose} items={items}/>
            <RetailPriceModal onClose={handleClose} items={items}/>
            <MarkupModal onClose={handleClose} items={items}/>
            <PriceInfoModal onClose={handleClose} items={items}/>
            <QuantityModal onClose={handleClose} items={items}/>
            <DeliveryModal onClose={handleClose} items={items}/>
            <OrderNumberModal onClose={handleClose} items={items}/>
            <CommitedModal selected={selected} onClose={handleClose} items={items}/>
            <NoteModal selected={selected} onClose={handleClose} items={items}/>
            <hr/>
            <PrintModal selected={selected} items={items} />
            <CopyModal selected={selected} items={items} />
            <MergeModal selected={selected} items={items} />
            <DeleteModal selected={selected} onClose={handleClose} items={items} />
          </Menu>
        </Fab>
        <Gallery onClose={handleClose} items={items} />
      </Box>
    </Box>
  )
}